export { AppIcon30 } from './AppIcon30'
